import { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { Loader, Dialog } from '@sm-dashboard/ui-components';
import EventForm from '../../Events/EventForm/EventForm';
import { useFetch } from '@/hooks/useFetch';
import { eventsConfigurationUrl, eventsByIdUrl } from '@/constants';
import { Event, EventConfiguration } from '@sm-dashboard/types';
import { EventList } from '../../Events/Events';
import { HeatmapCenter } from './useCentersData';

interface CenterEventDialogProps {
  open: boolean;
  onClose: () => void;
  center: HeatmapCenter | null;
}

export const CenterEventDialog = ({ open, onClose, center }: CenterEventDialogProps) => {
  const { data: eventsConfiguration, loading: loadingConfig, fetchData: fetchEventsConfiguration } = useFetch();
  const { data: eventsData, loading: loadingEvents, fetchData: fetchEventData } = useFetch();
  const [eventList, setEventList] = useState<EventList | null>(null);

  useEffect(() => {
    if (open) {
      fetchEventsConfiguration({ method: 'GET', url: eventsConfigurationUrl });
    }
  }, [open]);

  useEffect(() => {
    if (open && center?.id && eventsConfiguration) {
      fetchEventData({
        method: 'GET',
        url: `${eventsByIdUrl}?page=0&rowsPerPage=1000`
      });
    }
  }, [open, center?.id, eventsConfiguration]);

  useEffect(() => {
    if (eventsData && eventsConfiguration && center?.id) {
      const events =
        (eventsData as { rows?: Event[]; count?: number }).rows || (Array.isArray(eventsData) ? eventsData : []);
      const event = events.find((e: Event) => e.id === center.id);

      if (event) {
        const config = (eventsConfiguration as EventConfiguration[]).find(
          (c: EventConfiguration) => c.operationId === event.operationId
        );
        setEventList({
          config,
          data: event
        });
      } else {
        setEventList(null);
      }
    }
  }, [eventsData, eventsConfiguration, center?.id]);

  const handleDeleteEvent = () => {
    onClose();
  };

  const handleFormClose = () => {
    onClose();
  };

  const isLoading = loadingConfig || loadingEvents || !eventList;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth contentPadding="none">
      <Box sx={{ position: 'relative' }}>
        {isLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
            <Loader />
          </Box>
        ) : eventList ? (
          <Box sx={{ p: 2, backgroundColor: 'background.default' }}>
            <EventForm
              event={eventList}
              index={0}
              deleteEventFromList={handleDeleteEvent}
              expanded={0}
              // eslint-disable-next-line @typescript-eslint/no-empty-function
              handleAccordionsChange={() => () => {}}
              onFormClose={handleFormClose}
            />
          </Box>
        ) : null}
      </Box>
    </Dialog>
  );
};
